export default [
  {
    // TODO Alex
    path: 'Content/:l0101_id/Session/:l0401_id/CheckIn/:encrypted_content_class_session_identification_token',
    name: 'ContentClassSessionCheckIn',
    component: () => import('@/app/L0401ContentClassSession/ContentClassSessionCheckIn/PgContentClassSessionCheckIn.vue'),
    portalGroup: 'learn.my',
    meta: { title: '出席', authenticated: true }
  },
  {
    path: 'Content/:l0101_id/Session/:l0401_id',
    name: 'ContentClassSessionManage',
    component: () => import('@/app/L0401ContentClassSession/ContentClassSessionManage/PgContentClassSessionManage.vue'),
    portalGroup: 'learn.lecture',
    meta: { authenticated: true, title: '出席管理' }
  },
  {
    path: 'Content/:l0101_id/Session/:l0401_id/share/:encrypted_content_class_session_attendance_manage_token',
    name: 'ContentClassSessionManageShare',
    component: () => import('@/app/L0401ContentClassSession/ContentClassSessionManage/PgContentClassSessionManage.vue'),
    portalGroup: 'learn.lecture'
  }
]
